import React,{useState} from "react";
import "./style.css";
import backImage from "../../assets/images/IITGBackground.png"
import icon1 from "../../assets/images/icon1.png"
import icon2 from "../../assets/images/icon2.png"
import icon3 from "../../assets/images/icon3.png"
import icrageeLogo from "../../assets/images/icragee.png"
import Footer from "../../components/Footer/Footer";
import venueImage from "../../assets/images/venue.png"
import AboutCard from "../../components/AboutCard/AboutCard";
import auditoriumImage from "../../assets/images/auditorium.jpg"
import mapImage from "../../assets/images/map.png"
import Navbar from "../../components/Navbar/Navbar"
import Layout from "../../components/Layout/layout";
const AboutISET = () => {
    
    return(
        <Layout>
        <main className="bg-gray-100">
           
      <div className="flex justify-center">
      <div className="flex absolute md:mt-[-10vw] mt-[-35vw] md:flex-row flex-col items-center w-full justify-center gap-12">
        <div className="text-[55px] text-white" 
            style={{fontFamily: 'Bebas Neue', textShadow: '2px 1px 0px #000'}}
            >
                ABOUT ISET
            </div>
        </div>
      <div className="w-full md:w-3/4 md:px-20 px-10 py-32 border-2 my-10 bg-white text-justify">
            <div className="font-bold text-xl md:text-5xl text-sky-800 mb-10">
                INDIAN SOCIETY OF EARTHQUAKE TECHNOLOGY (ISET)
            </div>
            <div className="text-xl md:text-3xl mb-4">
            The ISET, established in 1962, is a founder member of the International Association for Earthquake Engineering (IAEE) and represents India on world for dealing with various aspects of earthquake engineering. The society is represented by its President as the National Delegate and the Vice- President as the Deputy National Delegate in the General Assembly of Delegates of the IAEE. A number of ISET members have served on the Executive Committee of the IAEE. The Executive Committee of ISET also acts as the ‘Indian National Committee on Earthquake Engineering’. The society has 14 local chapters with total current membership over 2100. The society a quarterly journal “ISET Journal of Earthquake Technology” since its inception. ISET gives honors and awards for recognition of the work done in India and abroad. The society organized 6th World Conference on Earthquake Engineering in New Delhi in 1977.
            </div>
            <div className="text-xl md:text-3xl text-blue-500 text-underline"><a href="https://iset.org.in/">Click here to visit the website</a></div>
            
        </div>
        
      </div>
      
        </main>
        </Layout>
    );
}
export default AboutISET;